import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import BannerSlider from '../components/BannerSlider';
import RunningBanner from '../components/RunningBanner';
import AttentionPopup from '../components/AttentionPopup';
import DailyHoroscope from '../components/DailyHoroscope';
import DailyPanchang from '../components/DailyPanchang';
import Services from '../components/Services';
import SlotCountdown from '../components/SlotCountdown';
import BookConsultation from '../components/BookConsultation';
import Vastu from '../components/Vastu';
import KundliCalculator from '../components/KundliCalculator';
import About from '../components/About';
import PhotoGallery from '../components/PhotoGallery';
import Testimonials from '../components/Testimonials';
import TarotSection from '../components/TarotSection';
import NumerologySection from '../components/NumerologySection';
import Contact from '../components/Contact';
import FloatingActions from '../components/FloatingActions';
import PoochoGurujiHero from '../components/PoochoGurujiHero';
import PricingLadder from '../components/PricingLadder';
import ExpertSpotlight from '../components/ExpertSpotlight';
import Ecosystem from '../components/Ecosystem';
import TrustBlock from '../components/TrustBlock';
import PremiumPoochoHero from '../components/poocho/PremiumPoochoHero';
import MediaStrip from '../components/poocho/MediaStrip';
import VideoTestimonials from '../components/poocho/VideoTestimonials';
import SampleAnswerGlimpse from '../components/poocho/SampleAnswerGlimpse';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Vivek Mudgal — Best Astrologer in Faridabad | ViratAstro"
        description="Vivek Mudgal - Best Vedic Astrologer in Faridabad, Haryana | Delhi NCR. 33+ years experience. Free Kundli, Daily Rashifal, Panchang, Tarot, Numerology, Gun Milan, Vastu. विवेक मुद्गल - फरीदाबाद, हरियाणा, दिल्ली NCR के सर्वश्रेष्ठ ज्योतिषी।"
        path="/"
        image="/brand/og/va-og-home.png"
        keywords="best astrologer faridabad, vedic astrologer delhi ncr, vivek mudgal, free kundli, daily rashifal, vastu consultant, gun milan, mangalik dosha, ज्योतिषी फरीदाबाद, ज्योतिष"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          '@id': 'https://viratastro.cloud/#localbusiness',
          name: 'ViratAstro — Acharya Vivek Mudgal',
          alternateName: ['विवेक मुद्गल ज्योतिषी', 'ViratAstro Faridabad'],
          image: 'https://viratastro.cloud/brand/va-cosmic-1024.png',
          url: 'https://viratastro.cloud/',
          telephone: '+91-9311369729',
          priceRange: '₹99 - ₹5,100',
          description: '33+ years of Vedic astrology by Acharya Vivek Mudgal — Kundli, Rashifal, Panchang, Vastu, Gun Milan, Tarot, Numerology, Muhurat & personal consultations.',
          address: {
            '@type': 'PostalAddress',
            streetAddress: 'Sector 15',
            addressLocality: 'Faridabad',
            addressRegion: 'Haryana',
            postalCode: '121007',
            addressCountry: 'IN',
          },
          geo: { '@type': 'GeoCoordinates', latitude: 28.4089, longitude: 77.3178 },
          openingHoursSpecification: [{
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            opens: '09:00', closes: '20:00',
          }],
          areaServed: [
            { '@type': 'City', name: 'Faridabad' },
            { '@type': 'City', name: 'Delhi' },
            { '@type': 'City', name: 'Gurugram' },
            { '@type': 'City', name: 'Noida' },
            { '@type': 'AdministrativeArea', name: 'Delhi NCR' },
            { '@type': 'Country', name: 'India' },
          ],
          aggregateRating: {
            '@type': 'AggregateRating', ratingValue: '4.9', reviewCount: '287', bestRating: '5',
          },
          sameAs: [
            'https://www.youtube.com/@ViratAstro',
            'https://www.instagram.com/viratastro',
            'https://www.facebook.com/viratastro',
          ],
        }}
      />
      <Header />
      <FloatingActions />
      {/* 1. Homepage Hero (Vivek Mudgal) */}
      <Hero />
      {/* 2. Poocho Guruji Luxury Hero */}
      <PremiumPoochoHero ctaHref="/poocho-guruji" ctaTestId="homepage-poocho-hero-cta" />
      {/* 3. Trust / Authority */}
      <TrustBlock />
      {/* 4. Featured In (Media Strip) */}
      <MediaStrip />
      {/* 5. Video Testimonials */}
      <VideoTestimonials />
      {/* 6. Sample Answer / Demo Prediction */}
      <SampleAnswerGlimpse />
      {/* 7. Pricing Ladder (₹99 / ₹299 / ₹999 / ₹5,100) */}
      <PricingLadder />
      {/* 8. Rest of Homepage */}
      <PoochoGurujiHero />
      <Ecosystem />
      <BannerSlider />
      <RunningBanner />
      <AttentionPopup />
      <DailyHoroscope />
      <DailyPanchang />
      <TarotSection />
      <NumerologySection />
      <Services />
      <SlotCountdown />
      <BookConsultation />
      <KundliCalculator />
      <Vastu />
      <About />
      <ExpertSpotlight />
      <PhotoGallery />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
